import { AllAllowCountryList, apiQueryUserIpAndCountryInfo } from '@jove-frontend/uikit';

export const useCountryInfo = () => {
  /**
   * request
   */
  const requestUserCountryCode = async (defaultCountryCode = 'GB') => {
    const [res] = await apiQueryUserIpAndCountryInfo();

    let country = '';
    if (res?.country === 'HK') {
      country = 'CN';
    } else {
      country = AllAllowCountryList.includes(res?.country) ? res.country : defaultCountryCode;
    }
    sessionStorage.setItem('jove-user-current-country', country);
    return country;
  };

  return { requestUserCountryCode };
};
